import Head from 'next/head';
import dynamic from 'next/dynamic';
import globalStyles from '../../styles/manager_apply';
import rsuite from '../../styles/rsuite-default';
import { GoogleAnalyticsBrandsiteScript } from '../../components/GoogleAnanlytics';

const EducationReserve = dynamic(
  () => import('../../components/BrandSites/ManagerApply/EducationReserve/EducationReserve'),
  { ssr: false },
);

export default function EducationReservePage() {
  return (
    <>
      <Head>
        <title>청소연구소 매니저 교육 예약</title>
        <meta name='description' content='원할 때 원하는 만큼! 최고시급, 빠른 정산!' />
        <meta property='og:type' content='website' />
        <meta property='og:url' content='https://www.cleaninglab.co.kr/manager_apply/education_reserve' />
        <meta property='og:title' content='청소연구소 매니저 시작하기' />
        <meta property='og:description' content='원할 때 원하는 만큼! 최고시급, 빠른 정산!' />
        <meta property='og:image:type' content='image/png' />
        <meta property='og:image:width' content='1200' />
        <meta property='og:image:height' content='708' />
        <meta property='og:image'
              content='https://cleanhome-dev.s3.ap-northeast-2.amazonaws.com/meta/meta_image_1200_708.png' />
        <meta property='og:image:secure_url'
              content='https://cleanhome-dev.s3.ap-northeast-2.amazonaws.com/meta/meta_image_1200_708.png' />
        <link rel='canonical' href='https://www.cleaninglab.co.kr/manager_apply/education_reserve' />
        <meta name='google-site-verification' content='203cocjYvGPrWQYfdbPqG9C6g2d_NsjzQVCA3fWPUZ8' />
        <GoogleAnalyticsBrandsiteScript />
        <script
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                        })(window,document,'script','dataLayer','GTM-PQZ79Z5');`,
          }}
        />

        {/* facebook pixel */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
                !function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)}(window, document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', '3196461740584204');
                    fbq('track', 'PageView');
              `,
          }}
        />
        <noscript>
          <img
            height='1'
            width='1'
            style={{ display: 'none' }}
            src='https://www.facebook.com/tr?id=3196461740584204&ev=PageView&noscript=1'
          />
        </noscript>
        {/* facebook pixel */}
        {/* 텐핑 전환 스크립트 */}
        <script src='//tenping.kr/scripts/cpa/tenping.cpa.V2_Domain.min.js'></script>
      </Head>
      <style jsx global>
        {globalStyles}
      </style>
      <style jsx global>
        {rsuite}
      </style>
      <EducationReserve />
    </>
  );
}
